import React from "react";
import { Modal, Button } from "react-bootstrap";
import PropTypes from "prop-types";
import { SUPPORT_MODAL, SUPPORT_LINKS } from "behaviour-analyzer-shared";

const SupportModal = ({ show, onClose }) => {
  const openLink = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton style={{ borderBottom: "none", paddingBottom: 0 }}>
        <Modal.Title style={{ width: "100%", textAlign: "center" }}>
          <span style={{ fontSize: "50px" }}>{SUPPORT_MODAL.emoji}</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding: "30px" }}>
        <h4 style={{ textAlign: "center", color: "#3f51b5", fontWeight: "bold", marginBottom: "15px" }}>
          {SUPPORT_MODAL.title}
        </h4>

        <p style={{ textAlign: "center", lineHeight: "1.6", color: "#333", marginBottom: "15px" }}>
          {SUPPORT_MODAL.message}
        </p>

        <p style={{ textAlign: "center", fontSize: "14px", lineHeight: "1.5", color: "#666", marginBottom: "20px" }}>
          {SUPPORT_MODAL.submessage}
        </p>

        <hr style={{ margin: "20px 0", borderColor: "#e0e0e0" }} />

        <h5 style={{ textAlign: "center", fontWeight: "bold", marginBottom: "15px", color: "#333" }}>
          {SUPPORT_MODAL.supportTitle}
        </h5>

        <div style={{ display: "flex", flexDirection: "column", gap: "12px", marginBottom: "25px" }}>
          <Button
            variant="warning"
            onClick={() => openLink(SUPPORT_LINKS.buyMeACoffee)}
            style={{
              backgroundColor: "#FF813F",
              borderColor: "#FF813F",
              fontWeight: "bold",
              padding: "12px",
            }}
          >
            ☕ Buy Me a Coffee
          </Button>

          <Button
            variant="primary"
            onClick={() => openLink(SUPPORT_LINKS.paypal)}
            style={{
              backgroundColor: "#003087",
              borderColor: "#003087",
              fontWeight: "bold",
              padding: "12px",
            }}
          >
            💳 PayPal
          </Button>
        </div>

        <Button
          variant="secondary"
          onClick={onClose}
          style={{ width: "100%", fontWeight: "bold", padding: "12px" }}
        >
          {SUPPORT_MODAL.continueButton}
        </Button>
      </Modal.Body>
    </Modal>
  );
};

SupportModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default SupportModal;
